import getCookie from "./csrftoken.js";

function EditInput(element) {
    this.containerElement = element,
    this.contentWrapper = null,
    this.editButton = null,
    this.inputId = this.containerElement.dataset.fileId ?? 0,
    this.formPath = this.containerElement.dataset.formPath ?? '',
    this.inputElement = null;
    this.fileName = '';
    this.isEditMode = false;

    this.initialize = function() {
        let wrapper = this.containerElement.getElementsByClassName("js-edit-input__wrapper");
        let button = this.containerElement.getElementsByClassName("js-edit-input__button");

        if (wrapper.length > 0) {
            this.contentWrapper = wrapper[0];
            this.fileName = this.contentWrapper.innerText;
        }
        if (button.length > 0) {
            this.editButton = button[0];
            this.editButton.addEventListener("click", this.editClicked.bind(this), false);
        }
    },

    this.restoreInitialState = function() {
        this.contentWrapper.innerHTML = "";
        let strongElement = document.createElement("strong");
        strongElement.innerText = this.fileName;
        this.contentWrapper.appendChild(strongElement);
        this.isEditMode = false;
    },

    this.setEditState = function() {
        this.contentWrapper.innerHTML = "";
        this.inputElement = document.createElement("input");
        this.inputElement.setAttribute('value', this.fileName);
        this.contentWrapper.appendChild(this.inputElement);
        this.inputElement.addEventListener("onblur", this.onInputBlur.bind(this), false);
        this.inputElement.addEventListener("keydown", this.onEnterPress.bind(this), false);
        this.isEditMode = true;
    },

    this.onEnterPress = function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.fileName = this.inputElement.value;
            this.saveChanges();
            this.restoreInitialState();
        }
    },

    this.saveChanges = function() {
        let url = this.formPath + this.inputId + '/';
        let xhr = new XMLHttpRequest();
        let params = "fileName=" + this.fileName;
        let csrftoken = getCookie('csrftoken');
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
        xhr.onreadystatechange = function() { // Call a function when the state changes.
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                console.log('Update complete');
            }
        }
        xhr.send(params);
    }

    this.onInputBlur = function(event) {
        event.preventDefault();
        console.log('onblur');
        this.restoreInitialState();
    },

    this.editClicked = function(event) {
        if (this.isEditMode){
            this.restoreInitialState();
        } else {
            this.setEditState();
        }
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    let editInputs = document.getElementsByClassName('js-edit-input');
    for (var i = editInputs.length - 1; i >= 0; i--) {
        let input = new EditInput(editInputs[i]);
        input.initialize();
    }
});